import React from "react";

interface FileIconProps {
  className?: string;
  onClick?: () => void;
}

export const FileIcon = ({ className, onClick }: FileIconProps) => (
  <svg
    className={className}
    onClick={onClick}
    width="15"
    height="21"
    viewBox="0 0 18 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.3438 4.59375C17.7812 5.03125 18 5.5625 18 6.1875V21.75C18 22.375 17.7812 22.9062 17.3438 23.3438C16.9062 23.7812 16.375 24 15.75 24H2.25C1.625 24 1.09375 23.7812 0.65625 23.3438C0.21875 22.9062 0 22.375 0 21.75V2.25C0 1.625 0.21875 1.09375 0.65625 0.65625C1.09375 0.21875 1.625 0 2.25 0H11.8125C12.4375 0 12.9688 0.21875 13.4062 0.65625L17.3438 4.59375ZM16.2656 5.67188L12.3281 1.73438C12.2344 1.64062 12.125 1.5625 12 1.5V6H16.5C16.4375 5.875 16.3594 5.76562 16.2656 5.67188ZM15.75 22.5C15.9688 22.5 16.1406 22.4219 16.2656 22.2656C16.4219 22.1406 16.5 21.9688 16.5 21.75V7.5H11.625C11.3125 7.5 11.0469 7.39063 10.8281 7.17188C10.6094 6.95312 10.5 6.6875 10.5 6.375V1.5H2.25C2.03125 1.5 1.84375 1.57813 1.6875 1.73438C1.5625 1.85938 1.5 2.03125 1.5 2.25V21.75C1.5 21.9688 1.5625 22.1406 1.6875 22.2656C1.84375 22.4219 2.03125 22.5 2.25 22.5H15.75Z"
      fill="black"
    />
  </svg>
);

FileIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
